module.exports = __webpack_public_path__ + "static/media/L1.686dae8d.jpg";